document.addEventListener('alpine:init', () => {
  Alpine.data('CartFooter', () => ({
    footerRoot: null,
    _onUpdate: null,
    _openCart() {
      if (window.__hgCartRecoveryPending) return;
      window.__hgCartRecoveryPending = true;
      const root = window.Shopify?.routes?.root || '/';
      window.location.assign(window.theme?.routes?.cart_url || `${root}cart`);
    },
    _morphFooter(e) {
      if (!this.footerRoot) return;
      try {
        const html = e?.detail?.response?.sections?.['cart-footer'];
        const nextFooter = typeof html === 'string' && html.trim()
          ? querySelectorInHTMLString('[data-cart-footer]', html) : null;
        // Keep the checkout controls intact while navigating to fresh cart totals.
        if (!nextFooter) { this._openCart(); return; }
        Alpine.morph(this.footerRoot, nextFooter.outerHTML, {
          updating(el, toEl, childrenOnly, skip) {
            if (el.classList?.contains('additional-checkout-buttons')) skip();
          },
        });
      } catch (error) {
        console.error('Hunted+Gathered cart totals could not refresh', error);
        this._openCart();
      }
    },
    init() {
      this.footerRoot = this.$root;
      this._onUpdate = this._morphFooter.bind(this);
      window.addEventListener('baseline:cart:afteradditem', this._onUpdate);
      window.addEventListener('baseline:cart:cartqtychange', this._onUpdate);
    },
    destroy() {
      window.removeEventListener('baseline:cart:afteradditem', this._onUpdate);
      window.removeEventListener('baseline:cart:cartqtychange', this._onUpdate);
    },
  }));
});
